export { Datacenter } from '@datadog/browser-core';
export { datadogRum } from './rum.entry';
export { RumEventCategory } from './rum';
//# sourceMappingURL=index.js.map